angular.module("ainapp")
    .controller("purchaseVoucherTrashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


            $scope.PageName = "Purchase Voucher Trash";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.loadKendo = function () {
                $scope.KendoGridSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {


                            if ($scope.selectedVoucher.NameVal == "Material Request") {
                                MainService.DeletedMaterialRequests(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Purchase Request") {
                                MainService.DeletedPurchaseRequests(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Purchase Enquiry") {
                                MainService.DeletedPurchaseEnquiries(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Purchase Quotation") {
                                MainService.DeletedPurchaseQuotations(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Purchase Order") {
                                MainService.DeletedPurchaseOrders(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Goods Received") {
                                MainService.DeletedGoodsReceiveds(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Purchase Invoice") {
                                MainService.DeletedPurchaseInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Direct Purchase Invoice") {
                                MainService.DeletedDirPurchaseInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Individual Purchase Invoice") {
                                MainService.DeletedIndPurchaseInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Import Purchase Invoice") {
                                MainService.DeletedImpPurchaseInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Export Purchase Invoice") {
                                MainService.DeletedExpPurchaseInvoices(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Purchase Return") {
                                MainService.DeletedPurchaseReturns(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else {
                                o.success({
                                    Data: [],
                                    Total: 0
                                });
                            }


                        }
                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                CreatedDate: {
                                    type: "date",
                                },
                                UpdatedDate: {
                                    type: "date",
                                },
                                VoucherNumber: {
                                    type: "string",
                                },
                                GrandTotal: {
                                    type: "number",
                                },
                                NetTotal: {
                                    type: "number",
                                },
                                TotalTax: {
                                    type: "number",
                                },
                                "Customer.Name": {
                                    type: "string",
                                },
                                "CreatedBy.UserName": {
                                    type: "string",
                                },
                                "UpdatedBy.UserName": {
                                    type: "string",
                                },
                            }
                        }
                    },
                    pageSize: 30,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.KendoGridOptions = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 650,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.KendoGridSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: [
                        {
                            field: "VoucherNumber",
                            title: "#",
                            width: "100px"
                    },
                        {
                            field: "Date",
                            template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Date",
                            width: "100px"
                    },
                        {
                            field: "Customer.Name",
                            title: "Customer",
                            width: "200px"
                    },
                        {
                            field: "NetTotal",
                            title: "Net Total",
                            width: "100px"
                    }, {
                            field: "TotalTax",
                            title: "Total Tax",
                            width: "100px"
                    }, {
                            field: "GrandTotal",
                            title: "Grand Total",
                            width: "100px"
                    },
                        {
                            field: "CreatedBy.UserName",
                            title: "Created By",
                            width: "100px"
                    },
                        {
                            field: "CreatedDate",
                            template: "<p> {{dataItem.CreatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Created Date",
                            width: "100px"
                    },
                        {
                            field: "UpdatedBy.UserName",
                            title: "Updated By",
                            width: "100px"
                    },
                        {
                            field: "UpdatedDate",
                            template: "<p> {{dataItem.UpdatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Updated Date",
                            width: "100px"
                    },

                  ],
                };


            }


            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VArray = [];

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    var temp1 = {
                        Id: 1,
                        Name: "Material Request",
                        NameVal: "Material Request"
                    };
                    if ($scope.CompanyProfile.MaterialRequest != "" & $scope.CompanyProfile.MaterialRequest != null) {
                        temp1.Name = $scope.CompanyProfile.MaterialRequest;
                    }
                    $scope.VArray.push(temp1);

                    var temp2 = {
                        Id: 2,
                        Name: "Purchase Request",
                        NameVal: "Purchase Request"
                    };
                    if ($scope.CompanyProfile.PurchaseRequest != "" & $scope.CompanyProfile.PurchaseRequest != null) {
                        temp2.Name = $scope.CompanyProfile.PurchaseRequest;
                    }
                    $scope.VArray.push(temp2);

                    var temp3 = {
                        Id: 3,
                        Name: "Purchase Enquiry",
                        NameVal: "Purchase Enquiry"
                    };
                    if ($scope.CompanyProfile.PurchaseEnquiry != "" & $scope.CompanyProfile.PurchaseEnquiry != null) {
                        temp3.Name = $scope.CompanyProfile.PurchaseEnquiry;
                    }
                    $scope.VArray.push(temp3);

                    var temp4 = {
                        Id: 4,
                        Name: "Purchase Quotation",
                        NameVal: "Purchase Quotation"
                    };
                    if ($scope.CompanyProfile.PurchaseQuotation != "" & $scope.CompanyProfile.PurchaseQuotation != null) {
                        temp4.Name = $scope.CompanyProfile.PurchaseQuotation;
                    }
                    $scope.VArray.push(temp4);

                    var temp5 = {
                        Id: 5,
                        Name: "Purchase Order",
                        NameVal: "Purchase Order"
                    };
                    if ($scope.CompanyProfile.PurchaseOrder != "" & $scope.CompanyProfile.PurchaseOrder != null) {
                        temp5.Name = $scope.CompanyProfile.PurchaseOrder;
                    }
                    $scope.VArray.push(temp5);

                    var temp6 = {
                        Id: 6,
                        Name: "Goods Received",
                        NameVal: "Goods Received"
                    };
                    if ($scope.CompanyProfile.GoodsReceived != "" & $scope.CompanyProfile.GoodsReceived != null) {
                        temp6.Name = $scope.CompanyProfile.GoodsReceived;
                    }
                    $scope.VArray.push(temp6);

                    var temp7 = {
                        Id: 7,
                        Name: "Purchase Invoice",
                        NameVal: "Purchase Invoice"
                    };
                    if ($scope.CompanyProfile.PurchaseInvoice != "" & $scope.CompanyProfile.PurchaseInvoice != null) {
                        temp7.Name = $scope.CompanyProfile.PurchaseInvoice;
                    }
                    $scope.VArray.push(temp7);

                    var temp8 = {
                        Id: 8,
                        Name: "Direct Purchase Invoice",
                        NameVal: "Direct Purchase Invoice"
                    };
                    if ($scope.CompanyProfile.DirPurchaseInvoice != "" & $scope.CompanyProfile.DirPurchaseInvoice != null) {
                        temp8.Name = $scope.CompanyProfile.DirPurchaseInvoice;
                    }
                    $scope.VArray.push(temp8);

                    var temp9 = {
                        Id: 9,
                        Name: "Individual Purchase Invoice",
                        NameVal: "Individual Purchase Invoice"
                    };
                    if ($scope.CompanyProfile.IndPurchaseInvoice != "" & $scope.CompanyProfile.IndPurchaseInvoice != null) {
                        temp9.Name = $scope.CompanyProfile.IndPurchaseInvoice;
                    }
                    $scope.VArray.push(temp9);

                    var temp10 = {
                        Id: 10,
                        Name: "Import Purchase Invoice",
                        NameVal: "Import Purchase Invoice"
                    };
                    if ($scope.CompanyProfile.ImpPurchaseInvoice != "" & $scope.CompanyProfile.ImpPurchaseInvoice != null) {
                        temp10.Name = $scope.CompanyProfile.ImpPurchaseInvoice;
                    }
                    $scope.VArray.push(temp10);

                    var temp11 = {
                        Id: 11,
                        Name: "Export Purchase Invoice",
                        NameVal: "Export Purchase Invoice"
                    };
                    if ($scope.CompanyProfile.ExpPurchaseInvoice != "" & $scope.CompanyProfile.ExpPurchaseInvoice != null) {
                        temp11.Name = $scope.CompanyProfile.ExpPurchaseInvoice;
                    }
                    $scope.VArray.push(temp11);

                    var temp12 = {
                        Id: 12,
                        Name: "Purchase Return",
                        NameVal: "Purchase Return"
                    };
                    if ($scope.CompanyProfile.PurchaseReturn != "" & $scope.CompanyProfile.PurchaseReturn != null) {
                        temp12.Name = $scope.CompanyProfile.PurchaseReturn;
                    }
                    $scope.VArray.push(temp12);

                    $scope.selectedVoucher = $scope.VArray[0];
                    $scope.loadKendo();
                    $.LoadingOverlay("hide");

                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.refresh = function () {
                $scope.selectedVoucher = $scope.VArray[0];
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.changeView = function (data) {
                $scope.selectedVoucher = data;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


                }])
